import React, { Component } from "react";
import { ControlLabel, PageHeader, ListGroup, Form, FormControl, FormGroup, Col, ListGroupItem, PanelGroup, Panel } from "react-bootstrap";
import { invokeGetAthleteExerciseHistory } from "../../utils/AwsInvoke";
import { getMeasureTitle }          from "../../utils/Measure";
import { freeform_id }              from "../../utils/Constants";
import LoaderButton                 from "../../components/LoaderButton";
import YouTubeThumbnail             from "../../components/YouTubeThumbnail";
import YouTubePlayer                from "../../components/YouTubePlayer";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import uniqueId                     from 'lodash/uniqueId';
import { XYPlot,
         Crosshair,
         DiscreteColorLegend,
         FlexibleWidthXYPlot,
         HorizontalGridLines,
         LineSeries,
         LineMarkSeries,
         VerticalGridLines,
         XAxis,
         YAxis }        from 'react-vis';
import "../../css/ExerciseHistory.css";
import '../../css/react-vis/style.css';

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;

var post_survey_data  = [];
var post_survey_data2 = [];

const axisProps = {
  tickSizeInner: 0,
  style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};


var POST_WORKOUT_ITEMS;

export default class ExerciseHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title:        `${this.props.match.params.title}`,
            program_id:   `${this.props.match.params.program_id}`,
            week_tracker: `${this.props.match.params.week_tracker}`,
            exercise_id: `${this.props.match.params.exercise_id}`,
            youtube_id: `${this.props.match.params.yt_id}`,
            activeKey: 1,
            isLoading: true,
            list: [],
            crosshairPostValues:     [] //post_survey_data
        };
    }

    async componentDidMount() {

        if (!this.props.isAuthenticated)
            return;

        try {
            this.renderExerciseSetList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }

    componentWillUnmount() {
        ////  RESET ALL SURVEY DATA FOR NEW MEMBER  ////
        post_survey_data  = [];
        post_survey_data2 = [];
        /*this.setState({
            asessInbodyChartData: []
        })*/
    }

    async renderExerciseSetList() {
        var user_id     = this.props.globalUserId;

        var exercise_id = this.state.exercise_id;
        var results     = await invokeGetAthleteExerciseHistory(user_id, exercise_id);

        if(results.status) {
            var list   = results.data.metrics;
            var one_rm = results.data.one_rm;

            this.setState({
                list: list,
                one_rm: one_rm
            })
        }
    }

    renderProgramsList() {

        var exercise_data = this.renderWorkoutList();

        var programs = <span className="workoutDetailsContainer" >
                                <span className="">
                                     { exercise_data }
                                </span>
                        </span>

        return programs;
    }

    handleNoteClick = event => {
      event.preventDefault();
      this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>TS</h1>
                <p></p>
            </div>
        );
    }

    handleSelect (activeKey) {
        this.setState({ activeKey });
    }

    createMarkup(text) { return {__html: text}; };

    renderList() {
        return (
            <div className="list">
                {!this.state.isLoading && this.renderProgramsList()}
            </div>
        );
    }

    getSeconds(mmss) {
        var a = mmss.split(':'); // split it at the colons
        //console.log("mmss: " + mmss);
        //console.log("split: " + a);
        var seconds = ((a[0]) * 60 + (+a[1]));

        //console.log("Total secs: " + seconds);
        return seconds;
    }

     convertMMSS (totalSeconds) {
          var hours   = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
          var seconds = totalSeconds - (hours * 3600) - (minutes * 60);

          // round seconds
          seconds = Math.round(seconds * 100) / 100

          /* incl hours
              var result = (hours < 10 ? "0" + hours : hours);
              result += ":" + (minutes < 10 ? "0" + minutes : minutes);
              result += ":" + (seconds  < 10 ? "0" + seconds : seconds);*/
              var result = (minutes < 10 ? "0" + minutes : minutes);
                  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
          return result;
    }

    renderSetList() {
        var programs = [];
        var list   = this.state.list;
        var blocks = "";//this.state.block_ids;


        var workout = <span style={{display: "inline-block", width: "100%"}}></span>
        return workout;
    }

    renderExerciseBody = (start, focus, execute, goal) => {
        return <span></span>
    }

    handleGoBackPage = () => {
        this.props.history.goBack();
    }

    onMouseLeavePostWorkout = () =>{
        this.setState({crosshairPostValues: []});
    }

    onNearestXPostWorkout = (value, {index}) => {
         var x  = post_survey_data[index].y;
         var x2 = post_survey_data[index].x;
         var y  = post_survey_data2[index].y;//  + " hours";
         //var comments = post_survey_data2[index].comments;

         this.setState({
                         crosshairPostValues: [{x: x2, y: y}], //pre_survey_data.map(d => d[index])
                         crossHairPostX: x,
                         crossHairPostY: y,
                         crossHairPostDate: x2,
                         //crossHairPostComments: comments,
                       });
    };

    getAthleteChart () {
            var post_survey_exists = 0; //post_survey_data.length

            ////  If no data, display a "no-data" block  ////
            var post_survey_div;
            //if(post_survey_exists === 0) post_survey_div = <span style={{position:"relative", top: 75, left: "25%", padding: 15, border: "1px solid #ddd"}}>There is currently no survey data.</span>
            ////  End: No data

            return <span style={{position:"relative", left:-10}}>
                        { /*}<div style={{fontSize:22, textAlign:"center"}}>
                            { /*}<FontAwesomeIcon icon="clipboard-check" style={{fontSize: '1.6em', paddingRight: 8 }}/>* / }
                            <span style={{position:"relative", top:-4}}>
                                Chart Data
                            </span>
                        </div>*/ }
                        <span style={{display:"inline-block",width:"100%"}}>
                                 { post_survey_div }
                                  <FlexibleWidthXYPlot height={200}
                                                       xType="ordinal"
                                                       onMouseLeave={this.onMouseLeavePostWorkout} /*yDomain={[0, 100]}*/>
                                      <VerticalGridLines />
                                      <HorizontalGridLines />
                                      <YAxis title={POST_WORKOUT_ITEMS[0].title} {...axisProps}
                                             tickFormat={String} />
                                      <XAxis title={POST_WORKOUT_ITEMS[1].title} {...axisProps}
                                             tickFormat={String} />
                                      <LineMarkSeries data={post_survey_data}
                                                      size={2.5}
                                                      color="#4ec22a"
                                                      onNearestX={this.onNearestXPostWorkout} />
                                      <LineMarkSeries data={post_survey_data2}
                                                      size={2.5}
                                                      color="#e19722" />

                                      { /*}<Crosshair values={this.state.crosshairPostValues} >
                                              <div style={{background: 'black', borderRadius: 5, width: 200, maxWidth: 300, padding: 10}}>
                                                  <span style={{fontSize:18}}>Post-Workout</span>
                                                  <span style={{display: "block",fontSize:16}}>Workout Feeling: {this.state.crossHairPostX}</span>
                                                  <span style={{display: "block",fontSize:16}}>Training Level: {this.state.crossHairPostY}</span>
                                                  <span style={{display: "block",fontSize:16}}>Date: {this.state.crossHairPostDate}</span>
                                                  <span style={{display: "block",fontSize:14}}>
                                                      {this.state.crossHairPostComments}
                                                  </span>
                                              </div>
                                          </Crosshair> */ }
                                  </FlexibleWidthXYPlot>
                                  <DiscreteColorLegend items={POST_WORKOUT_ITEMS}
                                                       orientation='vertical'
                                                       style={{position:"relative", top:-7, left:35}}/>
                        </span>
                </span>
    }

    renderWorkoutList() {
        var yt_id   = this.state.youtube_id;
        var list = this.state.list;
        var exercise_arr = [];
        var old_date;
        var old_name;


        if(list.length === 0)
            exercise_arr.push(<div key={ uniqueId() } style={{fontSize:22}}><p/><p/>There's no historical data for this exercise.</div>)

        var k = 0;
        for(var key in list) {
            var name         = list[key].name;
            var set_number   = list[key].set_number;
            var set_id       = list[key].set_id;
            var metric_a     = list[key].metric_a;
            var metric_b     = list[key].metric_b;
            var metric_a_id  = list[key].metric_a_id;
            var metric_b_id  = list[key].metric_b_id;
            var date_created = list[key].date_created;
            var current_a_id = getMeasureTitle(metric_a_id);
            var current_b_id = getMeasureTitle(metric_b_id);

            if(metric_a_id === 2 && metric_b_id === 12)  current_a_id = "Lbs";
            if(metric_b_id === 12) current_b_id = "Reps";
            var new_date    = "";
            var brk2        = "";
            var one_rm      = "";
            var one_rep_max = "";
            var exercise_header = "";
            var metric_a_val = parseInt(metric_a).toFixed(0);
            var metric_b_val = parseInt(metric_b).toFixed(0);
            var date         = new Date(date_created).toLocaleString(('en-US'), {timeZone: 'UTC', month: 'long', day:'2-digit', hour: '2-digit'}); /*}, hour: '2-digit', minute:'2-digit'}) */
            var date_chart   = new Date(date_created).toLocaleString(('en-US'), {timeZone: 'UTC', month: 'long', day:'2-digit', hour: '2-digit', minute:'2-digit'})

                //// BEGIN: Graph Data
                //for(var k=0; k < 10; k++) {
                    //var date_created        = data3[key3].date_created;
                    //var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric' })
                    // var chart_date = k;
                    console.log("-----------------");
                    console.log("date_chart: " + date_chart);
                    console.log("metric_a_val: " + metric_a_val);
                    console.log("metric_a_val: " + typeof metric_a_val);
                    var t= k*3;
                    if(k==1) t = 2;
                    console.log("t: " + t);
                    post_survey_data.push({"x":  date_chart, "y": k});
                    post_survey_data2.push({"x": date_chart, "y": t}); // pounds
                //}
                k++;
                ////  ******  END: GRAPH DATA  ******  ////

            if(current_a_id === "Pounds (Lbs)") current_a_id = "Lbs";
            if(current_b_id === "Repetitions") current_b_id = "Reps";

            POST_WORKOUT_ITEMS = [
                {title: " " + current_a_id, color: "#4ec22a", strokeWidth: 10},
                {title: " " + current_b_id, color: "#e19722", strokeWidth: 10}
            ];

            if(old_name != name) {
                exercise_header = <div>
                                    { /*}<div>{this.getAthleteChart()}</div>
                                <br/>*/ }
                                    <div style={{fontSize:26}}>{ name }</div>
                                  </div>
            }

            if(old_date != date) {
                var data_ids = this.state.one_rm;
                for(var key in data_ids) {
                    var tmp_set_id = data_ids[key].set_id;
                    if(tmp_set_id === set_id) {
                        //console.log("==== tmp_id: " + tmp_set_id);
                        one_rep_max = data_ids[key].one_rep_max;
                    }
                    //console.log("one_rep_max: " + data_ids[key].one_rep_max);
                }


                new_date = date;
                brk2 = <br/>;
                if(one_rep_max === "" || one_rep_max === null || one_rep_max === undefined) one_rep_max = "n/a";

                one_rm = "1 Rep Max: " + one_rep_max; // + " - set_id: " + set_id;

            }

            exercise_arr.push(  <div key={ uniqueId() } className="dateLabel" style={{fontSize:18}}>
                                    {exercise_header}
                                    <div style={{position:"relative", top:"-5px",color:"#333"}}>
                                        { brk2 }
                                        { new_date }
                                        { brk2 }
                                        <span style={{position:"relative", top:"-2px", fontSize:"16px", color: "#666"}}>
                                        { one_rm }
                                        </span>
                                    </div>

                                    <span style={{color:"#666", fontWeight:"bold", paddingRight: 20, textAlign: "left"}}>Set { set_number }. </span>
                                { metric_a_val } { current_a_id } x  { metric_b_val } { current_b_id } <br/>
                                </div>
                              )
            old_date = date;
            old_name = name;
        }
        //console.log("**********    END   *************");

        var imageOrYouTube = <YouTubePlayer yt_id={yt_id} />

        // if no youtube video is avail. show an image
        if(yt_id == "empty_id" || yt_id === "0")
            imageOrYouTube = this.renderPlaceholderImage("Exercise History");

        var border_top = "5px solid #ccc";
        return (
            <span className="workoutDetailsSummar">
                    { imageOrYouTube }
                    <div>
                        <div className="workoutDetailsHistoryRow" style={{borderTop: border_top }}>
                            <span className="workoutDetailsDayViewLabel"
                                  onClick={this.handleGoBackPage}>
                                <span className="goBackDayViewGlyphIcon">
                                    <span className="glyphicon glyphicon-menu-left"/>
                                </span>
                                Exercise
                            </span>
                        </div>

                        <span className="workoutDetilsBodyPadding">
                            <br/>
                                { exercise_arr }
                        </span>
                    </div>
            </span>
        );
    }

    renderPlaceholderImage = (name) => {
        var cover_title        = this.state.title;
        var week_tracker       = this.state.week_tracker;
        var program_id         = this.state.program_id;

        return  (<span>
                        {/*}<span className="programBeginImage">
                            <img src={require('../../images/program_categories/abs.jpg')} width="100%"/>
                        </span>
                        <span className="programWorkoutDetailFadeImage">
                            <img src={require('../../images/utils/program_category_black_fade2.png')} height="105" width="100%"/>
                        </span>
                        <br/>
                        <span className="programWorkoutFreeformTitle">{name}</span>
                        <span style={{display:"block",height:130}}/>*/ }
                        <span className="programBeginImage">
                            <img src={require('../../images/program_categories/cardio1.jpg')} width="100%"/>
                        </span>
                        <span className="programWorkoutDetailFadeImage">
                            <img src={require('../../images/utils/program_category_black_fade2.png')} height="105" width="100%"/>
                        </span>
                        <span className="programWorkoutTitle"
                                  href={`/ProgramBegin/${program_id}/${cover_title}`}
                                  onClick={this.handleWorkoutDetails}
                                  style={{whiteSpace: "nowrap", overflowX:"hidden", color: "#fff"}}
                        >
                             {cover_title}
                        </span>
                        <span className="programWorkoutDateTitle"
                              style={{fontSize:"24px", color: "#fff"}}
                              >
                             {week_tracker}
                        </span>
                        <span className="programWorkoutFreeformTitle" style={{color:"black"}}></span>
                        <span style={{display:"block",height:80}}/>
                 </span>)
    }

    render() {
        return (
            <div className="HomeProgramWorkoutDetails">

              {this.renderList()}
              { /*this.props.isAuthenticated ? this.renderNotes() : this.renderLander()*/ }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/exercise/ExerciseHistory.js